import NewProjects from './NewProjects';

export default NewProjects;
